import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getObjections } from "store/actions";

import Table from "./Table";

const AdvirtiseType = () => {
  const dispatch = useDispatch();
  const { objections, loading } = useSelector((state) => state.objections);

  useEffect(() => {
    dispatch(getObjections());
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <Table data={objections} loading={loading} />
    </div>
  );
};

export default AdvirtiseType;
